module.exports = __webpack_public_path__ + "img/13.5.COD.f1933bd1.png";